import getAxiosHttpType from 'crypto-js'
import {SeaAESPassword} from './systemConfig'


function getAxiosHead(){
  const headStr = "GETAXIOSHTTPTYPE"
  const iv = getAxiosHttpType.enc.Utf8.parse("GETAXIOSHTTPMODE");
  const headData = SeaAESPassword
  var headJSONStr = getAxiosHttpType.enc.Utf8.parse(headStr)
  var decrypt = getAxiosHttpType.AES.decrypt(headData, headJSONStr, {mode:getAxiosHttpType.mode.CBC,padding: getAxiosHttpType.pad.Iso10126,iv:iv})
  return getAxiosHttpType.enc.Utf8.stringify(decrypt).toString()
}

//加密 A5tN2bW7rJ9gS0dP6kZ4hC1qC8xA5t2b
function getAxiosJSONstr(word){
  if(!word){
    return null
  }
  if(typeof(word) != 'string'){
    word = JSON.stringify(word)
  }
  const axiosHeadStr = getAxiosHead()
  var headJSONStr  = getAxiosHttpType.enc.Utf8.parse(axiosHeadStr) //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var srcs = getAxiosHttpType.enc.Utf8.parse(word)
  var encrypted = getAxiosHttpType.AES.encrypt(srcs, headJSONStr, {mode:getAxiosHttpType.mode.ECB, padding: getAxiosHttpType.pad.Pkcs7})
  let data = {
    text: encrypted.toString()
  }
  return data

}

function getAxiosHeadJSONstr(word){

  if(!word){
    return null
  }
  try {
    const axiosHeadStr = getAxiosHead()
    var headJSONStr  = getAxiosHttpType.enc.Utf8.parse(axiosHeadStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var decrypt = getAxiosHttpType.AES.decrypt(word, headJSONStr, {mode:getAxiosHttpType.mode.ECB,padding: getAxiosHttpType.pad.Pkcs7})
    return getAxiosHttpType.enc.Utf8.stringify(decrypt).toString();
  } catch (error) {
    return word
  }
}

// 加密location消息头
function encryptionLoc(word) {
  if(!word){
    return null
  }
  if(typeof(word) != 'string'){
    word = JSON.stringify(word)
  }
  const axiosHeadStr = 'pYX9rcTLhe41eapG4CHAwbQTxBN+8q9j'
  var headJSONStr  = getAxiosHttpType.enc.Utf8.parse(axiosHeadStr) //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var srcs = getAxiosHttpType.enc.Utf8.parse(word)
  var encrypted = getAxiosHttpType.AES.encrypt(srcs, headJSONStr, {mode:getAxiosHttpType.mode.ECB, padding: getAxiosHttpType.pad.Pkcs7})
  let data = {
    text: encrypted.toString()
  }
  return data
}

export const SeaAesUtil = {
  getAxiosJSONstr: (word) => getAxiosJSONstr(word),
  getAxiosHeadJSONstr: (word) => getAxiosHeadJSONstr(word),
  encryptionLoc: (word) => encryptionLoc(word)
}



// WEBPACK FOOTER //
// ./src/util/SeaAESUtils.js